import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import React from 'react';

import { InputField } from 'Elements/Form';

import CustomerSelect from '../shared/CustomerSelect';
import TrafficSelect from '../shared/TrafficSelect';
import VehicleTypeSelect from '../shared/VehicleTypeSelect';

export default function VehicleBasicInfo() {
  return (
    <Card elevation={1}>
      <CardHeader title="Ajoneuvotiedot" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField name="vehicle.identifier" />
          </Grid>
          <Grid item xs={6}>
            <InputField name="vehicle.reg" />
          </Grid>
          <Grid item xs={6}>
            <VehicleTypeSelect name="vehicle.vehicle_type_id" />
          </Grid>
          <Grid item xs={6}>
            <TrafficSelect name="vehicle.traffic_id" />
          </Grid>
          <Grid item xs={12}>
            <CustomerSelect name="vehicle.customer_id" />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
